// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../../styles/variables.css\"","textDefault":"#808080","primary":"#56CCF2","container":"ptINyUBARAmw8uJOsCWwR","content":"_3eRPs-iLj5sFZmpVJL6KyT","title":"_2sgvlEzgrNfg0wMxAEbGPh","price":"_1GfGdrWdTrgbJC4Fa4xNqq","description":"e5ER4MDZCysHRn4LmMf40","advantage":"_2zz5Lp9zt2zd2v_UoKLRLP"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Billing/components/Pricing.mod.css
// module id = 1064
// module chunks = 0